import Text from '@shared/components/content/text';
import { Card } from '@shared/components/ui/card';
import { cn } from '@shared/lib/utils';
import { ReactNode } from 'react';

interface ChartCardProps {
  title: string;
  description?: string;
  legend?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function ChartCard({
  title,
  description,
  legend,
  className,
  children,
}: ChartCardProps) {
  return (
    <Card className={cn('flex flex-col gap-3 p-5', className)}>
      <div className="flex items-start justify-between gap-4">
        <div className="flex flex-col gap-0.5">
          <Text variant="cardTitle" className="text-primary-800">
            {title}
          </Text>
          {description && <Text variant="subtle">{description}</Text>}
        </div>
        {legend && <div className="flex items-center gap-4">{legend}</div>}
      </div>
      <div className="min-h-56 w-full flex-1">{children}</div>
    </Card>
  );
}
